// Feature 012: the variant groups of the visible calendar period. Nothing pushes group changes,
// so the boards refetch on period change and whenever a group action reports a change.
import {useCallback, useEffect, useState} from "react";
import {getVariantGroups} from "../../api";
import {VariantGroupType} from "../../redux/Content/VariantGroup/types";

const CHANGED = 'm9s:variantGroupsChanged';
const CREATE = 'm9s:variantGroupCreate';

/** Tell every board showing groups to refetch them (after a pick, edit, cancel…). */
export function notifyVariantGroupsChanged(): void {
    window.dispatchEvent(new Event(CHANGED));
}

/** Ask the calendar to open the "new variant group" form. */
export function requestVariantGroupCreate(): void {
    window.dispatchEvent(new Event(CREATE));
}

export function onVariantGroupCreateRequest(listener: () => void): () => void {
    window.addEventListener(CREATE, listener);
    return () => window.removeEventListener(CREATE, listener);
}

export function useVariantGroups(start: Date, end: Date): { groups: VariantGroupType[]; reload: () => void } {
    const [groups, setGroups] = useState<VariantGroupType[]>([]);
    const startTs = Math.floor(start.getTime() / 1000);
    const endTs = Math.floor(end.getTime() / 1000);

    const reload = useCallback(() => {
        getVariantGroups({start: startTs, end: endTs + 86400, limit: 200})
            .then((response: any) => setGroups(Array.isArray(response?.items) ? response.items : []))
            .catch(() => setGroups([]));
    }, [startTs, endTs]);

    useEffect(() => {
        reload();
    }, [reload]);

    useEffect(() => {
        window.addEventListener(CHANGED, reload);
        return () => window.removeEventListener(CHANGED, reload);
    }, [reload]);

    return {groups, reload};
}
